import { useGetList } from 'react-admin';
import { GROUP_USERS } from '@/utils/CONST';
import { GroupUser } from '@/utils/types';
import { composeUri } from '@/utils/compose';

interface Output {
    isLoading: boolean;
    groupUser: GroupUser | undefined;
    refetch: any;
}

interface Params {
    agencyId: string | undefined;
    enabled?: boolean;
}

const useGetGroupUser = ({ agencyId, enabled }: Params): Output => {
    const { data, isLoading, refetch }: any = useGetList(
        GROUP_USERS,
        {
            filter: {
                serialization_groups: ['read_group_users_group_avatars'],
                id: agencyId ? composeUri(GROUP_USERS, agencyId) : undefined,
            },
        },
        {
            enabled: !!agencyId && (enabled !== false),
        },
    );

    return {
        groupUser: data?.[0],
        isLoading,
        refetch,
    };
};

export default useGetGroupUser;







